import styled from 'styled-components'

export const Mark = styled.span`
  color: ${({ color }) => color ? color : 'currentColor'};
`
